var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvoices = function SvgInvoices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C0C5D2",
    d: "M.1 0v22h16V4.6L11.5 0zm11 2.4L13.7 5h-2.6zm3 17.6h-12V2h7v5h5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0C5D2",
    d: "M12.1 9h-8v2h8zM9.1 13h-5v2h5z"
  })));
};
export default SvgInvoices;